import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Segmented } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { ROUTES } from '@shared/config/routes';

export function SettingsNav() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const items = [
    { value: ROUTES.settingsAccount, label: t('settings.tabs.account'), icon: <UserOutlined /> },
    { value: ROUTES.settingsSecurity, label: t('settings.tabs.security'), icon: <LockOutlined /> },
  ];
  const active = items.find((i) => pathname.startsWith(i.value))?.value ?? items[0]!.value;
  return (
    <Segmented
      value={active}
      onChange={(v) => navigate(v as string)}
      options={items.map((i) => ({
        value: i.value,
        label: (
          <span style={{ display: 'inline-flex', gap: 6, alignItems: 'center' }}>
            {i.icon}
            {i.label}
          </span>
        ),
      }))}
    />
  );
}
